import resolveOutletExpirationOption from '../components/OrderManager/resolveOutletExpirationOption'

const buildOrderCatalogItem = (orderProduct, outletProductData = null) => {
  const isOutlet = orderProduct?.isOutlet === true

  if (!isOutlet) {
    return { isOutlet: false }
  }

  const outletReason =
    orderProduct.outletReasonType || orderProduct.outletReason || outletProductData?.outletReason || null
  const isExpirationOutlet = outletReason === 'productExpiration'
  const expirationOption =
    isExpirationOutlet && outletProductData
      ? resolveOutletExpirationOption(outletProductData, orderProduct.outletOptionId)
      : null
  const missingExpirationOption =
    isExpirationOutlet &&
    orderProduct.outletOptionId != null &&
    orderProduct.outletOptionId !== '' &&
    !expirationOption

  return {
    id: orderProduct.id,
    isOutlet: true,
    outletReason,
    expirationOption,
    missingExpirationOption,
    outletOptionId: orderProduct.outletOptionId,
  }
}

export default buildOrderCatalogItem
